<main class="container py-5"><h1>Acesso não concedido</h1><p>Sua conta não possui a concessão necessária para esta área.</p><a routerLink="/projetos">Voltar aos projetos autorizados</a></main>
